import type { FaireProductEntity } from "../../entity_types/product";

export const p_bsvemk8pqt: FaireProductEntity = {
  token: "p_bsvemk8pqt",
  type: "product",
  name: "TY Cheerful Rug",
  brandToken: "b_1sahwzac",
  brandName: "Hammerpress",
  imageUrl:
    "https://cdn.faire.com/fastly/d768421b84ee2a4c5b4ed86a452c19605d01beee44c31aa08a611b88557245bb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/100bc0ded5d511dec803716b05ed8387b32b53eafaa099afd1f905b6997ae6ef.jpeg",
  ],
  priceDollars: 3,
  description:
    'Folding note card with kraft envelope. Letterpress printed on 110lb. Recycled white paper. Blank inside.\n\nCard size: 4.25" x 5.50" (folded).\n\nPackaged in plant-based polylactic acid (PLA) certified compostable bag.\n\nDesigned and letterpress printed at our studio in Kansas City, Missouri. Made in USA.',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:02.198Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
